module.exports = __webpack_public_path__ + "static/abby_h.c1345d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/abby_h.png
// module id = 1710
// module chunks = 35783957827783